import { QueryConfig } from "store/utils/query-config";

export const contactsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-metaData.createdTime"],
  },
};
